export default "__VITE_ASSET__Bqg78yzx__"